/** Returns true if input starts with a digit or + (likely a phone number, not email) */
export function looksLikePhone(value: string): boolean {
  return /^[+\d]/.test(value.trim());
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/** Validates raw US phone input — accepts 10 digits or 11 with leading 1 */
export function isValidUSPhone(phone: string): boolean {
  const digits = phone.replace(/\D/g, "");
  return (
    digits.length === 10 || (digits.length === 11 && digits.startsWith("1"))
  );
}

/** Validates stored E.164 format: +1 followed by exactly 10 digits */
export function isValidE164Phone(phone: string): boolean {
  return /^\+1\d{10}$/.test(phone);
}

/** Normalize raw phone input to E.164 format */
export function toE164(input: string): string {
  const digits = input.replace(/\D/g, "");
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return `+${digits}`;
}
